@for (message of messages | async; track message; let i = $index) {
<p
  class="message-bar {{ message.type }}"
  [style.bottom]="toOffset(i)"
  (click)="removeAllMessages()"
>
  {{ message.text }}
</p>
}
